import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import { UnitySessionStatus } from '@unity/clients';
import { OutsideContainerComponent } from '@unity/layouts/outside-container/outside-container.component';
import { LayoutService } from '@unity/services/layout.service';

@Component({
  selector: 'unity-login-pending-page',
  standalone: true,
  imports: [KENDO_LAYOUT, RouterLink, OutsideContainerComponent],
  templateUrl: './login-pending-page.component.html',
  styleUrl: './login-pending-page.component.scss',
})
export class LoginPendingPageComponent {
  private readonly layoutService = inject(LayoutService);

  protected detailCardGridLayoutGap = this.layoutService.detailCardGridLayoutGap;

  public readonly $status = input(UnitySessionStatus[UnitySessionStatus.Unknown], { alias: 'status' });

  protected readonly $registrationStatus = computed(() => {
    const statusAsString = this.$status();
    return UnitySessionStatus[statusAsString as keyof typeof UnitySessionStatus];
  });
}
